import { cleanup, render, screen } from '@testing-library/react';
import * as React from 'react';

import translations from '../../translations';
import SortUp from './sort-up';

translations.init();

function TestComponent() {
  return <SortUp />;
}

describe('sort up icon', () => {
  afterEach(() => {
    cleanup();
  });

  test('should render the sort up icon', () => {
    render(<TestComponent />);
    const svg = screen.getByTestId('sort-up');

    expect(svg).toBeDefined();
    expect(svg.firstChild.nodeName.toLowerCase()).toBe('path');
  });
});
